/*
 *    Copyright (c) 2018-2025, lengleng All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: lengleng (wangiegie@gmail.com)
 */
import request from '@/router/axios'
const menuService = {
  getUser() {
    return request({
      url: '/a/sys/menu/user-menu',
      method: 'get'
    })
  },
  fetchTree(query) {
    return request({
      url: '/a/sys/menu/tree',
      method: 'get',
      params: query
    })
  },
  page(query) {
    return request({
      url: '/a/sys/menu/',
      method: 'get',
      params: query
    })
  },
  save(obj) {
    return request({
      url: '/a/sys/menu/',
      method: 'post',
      data: obj
    })
  },
  find(id) {
    return request({
      url: '/a/sys/menu/' + id,
      method: 'get'
    })
  },
  remove(id) {
    return request({
      url: '/a/sys/menu/' + id,
      method: 'delete'
    })
  },
  sortUpdate(obj) {
    return request({
      url: '/a/sys/menu/sort-update',
      method: 'post',
      data: obj
    })
  },
  lock(id) {
    return request({
      url: '/a/sys/menu/' + id,
      method: 'put'
    })
  },
  // 查询公章管理数量
  getWaitSealCount() {
    return request({
      url: `/api/contractAttachedFile/getWaitSealCount`,
      method: 'get',
    })
  },
  //钉钉免登陆
  dingtalkLogin(query) {
    return request({
      url: '/api/dingtalk/login',
      method: 'get',
      params: query
    })
  },
  //   获取审批对象是否已审批（true-已审批；false-未审批）
  processIsApproved(query) {
    return request({
      url: '/api/audit/process/isApproved',
      method: 'get',
      params: query
    })
  },
};
export default menuService